import { Center } from "@mantine/core";
import type { FC } from "react";
import { memo } from "react";

import styles from "./Copyright.module.scss";

const Copyright: FC = () => {
  return (
    <Center className={styles.copyright}>
      <small>©︎TANQ BASE</small>
    </Center>
  );
};

export const CopyrightMemo = memo(Copyright);
